import React from 'react';

import { colorsPalette } from '../../theme';

const ExclamationMarkIcon = (props) => {
  const color = props?.color || colorsPalette.violet;
  const subColor = props?.subColor || colorsPalette.iconViolet;

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5181 22.2237C38.5181 21.4055 39.1813 20.7422 39.9995 20.7422C40.8177 20.7422 41.481 21.4055 41.481 22.2237V47.0614C41.481 47.8796 40.8177 48.5429 39.9995 48.5429C39.1813 48.5429 38.5181 47.8796 38.5181 47.0614V22.2237ZM39.9995 59.2607C40.8177 59.2607 41.481 58.5974 41.481 57.7792C41.481 56.961 40.8177 56.2977 39.9995 56.2977C39.1813 56.2977 38.5181 56.961 38.5181 57.7792C38.5181 58.5974 39.1813 59.2607 39.9995 59.2607Z"
        fill={subColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5557 22.2218C35.5557 19.7672 37.5455 17.7773 40.0001 17.7773C42.4547 17.7773 44.4446 19.7672 44.4446 22.2218V47.0595C44.4446 49.5141 42.4547 51.504 40.0001 51.504C37.5455 51.504 35.5557 49.5141 35.5557 47.0595V22.2218ZM40.0001 56.2959C39.1819 56.2959 38.5186 56.9591 38.5186 57.7773C38.5186 58.5955 39.1819 59.2588 40.0001 59.2588C40.8183 59.2588 41.4816 58.5955 41.4816 57.7773C41.4816 56.9591 40.8183 56.2959 40.0001 56.2959ZM44.4446 57.7773C44.4446 60.2319 42.4547 62.2218 40.0001 62.2218C37.5455 62.2218 35.5557 60.2319 35.5557 57.7773C35.5557 55.3227 37.5455 53.3329 40.0001 53.3329C42.4547 53.3329 44.4446 55.3227 44.4446 57.7773ZM40.0001 20.7403C39.1819 20.7403 38.5186 21.4036 38.5186 22.2218V47.0595C38.5186 47.8777 39.1819 48.541 40.0001 48.541C40.8183 48.541 41.4816 47.8777 41.4816 47.0595V22.2218C41.4816 21.4036 40.8183 20.7403 40.0001 20.7403Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 77.037C60.455 77.037 77.037 60.455 77.037 40C77.037 19.545 60.455 2.96296 40 2.96296C19.545 2.96296 2.96296 19.545 2.96296 40C2.96296 60.455 19.545 77.037 40 77.037ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill={color}
      />
    </svg>
  );
};

export default ExclamationMarkIcon;
